<template>
  <div class="peracter">
    <div class="peracter-background">
      <div class="appHelmetysen">个人中心<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="peracter-infotn">
        <img src="../../public/obraoag/defatr.png" alt="">
        <div class="peracter-infotn-fumaon">
          <p class="peracter-infotn-fumaon-text">{{pefaon.USERNAME}}</p>
          <p class="peracter-infotn-fumaon-number">{{pefaon.lINTEGAR}}</p>
        </div>
      </div>
      <div class="peracter-record">
        <div class="peracter-record-frtion">
          <div class="peracter-record-frtion-conten peracter-record-frtion-contmr">
            <p class="peracter-record-frtion-contennm">{{penuds}}</p>
            <p class="peracter-record-frtion-contentx">欧宝卡</p>
          </div>
          <div class="peracter-record-frtion-conten">
            <p class="peracter-record-frtion-contennm">{{pedack}}</p>
            <p class="peracter-record-frtion-contentx">已连续签到</p>
          </div>
        </div>
      </div>
      <router-link :to="{path:'Myorder',query: {myTobeid: '0'}}">
        <div class="peracter-ficaon">我的订单</div>
      </router-link>
      <router-link :to="{path: 'pacuns'}">
        <div class="peracter-ficaon">我的优惠券</div>
      </router-link>
      <router-link :to="{path: 'inalch',query: {pembules: '6'}}">
        <div class="peracter-ficaon">会员手册</div>
      </router-link>
      <router-link :to="{path: 'inalch',query: {pembules: '7'}}">
        <div class="peracter-ficaon">积分规则</div>
      </router-link>
    </div>
    <botgaion snatus="6"></botgaion>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      loginID: '',
      pefaon: '',
      penuds: 0,
      pedack: ''
    }
  },
  created(){
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 获取个人信息
    this.$axios.post('wx/findByUserNameAndMessage',this.$qs.stringify({
      ID: this.loginID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.pefaon = res.data.userX;
    })
    .catch(() => {
      console.log('获取失败');
    });
    // 获取欧宝卡数量
    this.$axios.post('app/appUserOldCardPackage',this.$qs.stringify({
      token: this.loginID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      for(var i in res.data.data){
        if(res.data.data[i].cardtype == '5'){
          this.penuds++;
        }
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
    // 获取签到的天数
    this.$axios.post('app/client/signindays',this.$qs.stringify({
      MEMBER_ID: this.loginID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.pedack = res.data.SIGN_IN_NUMBER_OF_DAYS;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.push({name: 'pointsal'});
    }
  }
}
</script>
<style scoped>
  @import "obraocs/peracter.css";
</style>